<!-- section template -->
<template>
  <el-dialog
    :visible.sync="dialog2MixinVisible"
    width="˙786px"
    append-to-body
    :custom-class="`${$style.dialogOrderDetails} isStyleBase ${$globalIsDingBeauty ? $style.isStyleDingBeauty : ''}`"
    @closed="$Dialog2MixinOnDestroy"
  >
    <div class="dialogOrderDetails__title">
      {{ formatTitle }}
    </div>
    <div v-if="type === 'children' && isSingle" class="dialogOrderDetails__children fs-sm text-gray-2 text-center"> 提醒您，同次預約的未付款子項目 需要一併付款才能夠付款完成 </div>
    <div class="dialogOrderDetails__content mt-5">
      <template v-if="type === 'all'">
        <BaseTab v-if="!!containerItem.childrenContainers && containerItem.childrenContainers.items[0]" v-model="activeTab" :tab-list="tabList" name="activeTab" />
        <component :is="formatTextUpperCasefirst(activeTab)" :container-item="containerItem" is-dialog />
      </template>
      <template v-else-if="type === 'unPaidMain'">
        <Children :container-item="containerItem" :type="type" />
      </template>
      <template v-else>
        <Children :container-item="containerItem" :is-single="isSingle" />
      </template>
    </div>
  </el-dialog>
</template>

<script>
import dialog2Mixin from '../mixins/dialog2'
import formatTextUpperCasefirst from '@utils/format-text-upper-casefirst'

export default {
  components: {
    Children: () => import('@components/Order/OrderReservationChildrenList'),
    Detail: () => import('@components/Order/OrderReservationList'),
  },
  mixins: [dialog2Mixin],
  data() {
    return {
      containerItem: {},
      type: 'all',
      activeTab: 'detail',
      isSingle: false,
    }
  },
  computed: {
    formatTitle() {
      switch (this.type) {
        case 'all':
          return '總訂單明細'
        case 'children':
          return '子訂單明細'
        case 'unPaidMain':
          return '未付款明細'
        default:
          return '總訂單明細'
      }
    },
    tabList() {
      return Object.freeze([
        {
          title: '詳細預約內容',
          name: 'detail',
        },
        {
          title: this.childrenContainersTabText,
          name: 'children',
        },
      ])
    },
    childrenContainersTabText() {
      const isUnpaidChildren = this.containerItem?.childrenContainers?.items.filter((item) => {
        return item.paymentStatus === 'UNPAID' && !item.cancelDate
      })
      return `子訂單${isUnpaidChildren.length > 0 ? `<span class="text-danger">(${isUnpaidChildren.length}筆未付款)</span>` : ''}`
    },
  },
  watch: {
    '$route.name': {
      handler: function (search) {
        if (search !== this.type) {
          this.dialog2MixinVisible = false
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    formatTextUpperCasefirst,
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.dialogOrderDetails {
  @include max-lg {
    width: 75%;
  }
  :global {
    .dialogOrderDetails {
      @include unstyled;
      &__title {
        text-align: center;
        margin-bottom: 1.5rem;
        font-family: $font-title;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.5;
        color: $color-primary-dark;
      }

      &__content {
        font-size: 0.875rem;
        line-height: 2;
        color: $color-gray-2;
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .dialogOrderDetails {
        @include unstyled;
        &__title {
          font-size: 1.125rem;
          font-weight: 500;
          color: $color-secondary;
        }
      }
    }
  }
}
</style>
